module.exports = __webpack_public_path__ + "img/img_fitness_wearable_img2.c39cd311.png";